import { render, staticRenderFns } from "./__detail_prescription.vue?vue&type=template&id=59c22270&scoped=true&"
import script from "./__detail_prescription.vue?vue&type=script&lang=js&"
export * from "./__detail_prescription.vue?vue&type=script&lang=js&"
import style0 from "./__detail_prescription.vue?vue&type=style&index=0&id=59c22270&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c22270",
  null
  
)

export default component.exports